import { Search } from "lucide-react";
import useFilterOptionManager from "../../../CustomHooks/useFilterOptionManager";

const MobileFilterListItem = ({
  category,
  optionList,
  valueAddress,
  setSelectedItems,
  unsort,
}) => {
  const { handleSearch, handleCheckbox, searchList } = useFilterOptionManager({
    category,
    optionList,
    valueAddress,
    setSelectedItems,
    unsort,
  });

  return (
    <div className={`${"grid opacity-1"}`}>
      <p className="mx-2 mb-2 relative">
        <input
          type="text"
          placeholder="Search"
          onChange={handleSearch}
          className="filterSearchDropdownInput"
        />
        <Search size={16} className="absolute right-2 top-[10px]" />
      </p>
      {searchList && searchList.length > 0 ? (
        <ul
          className={`${searchList.length > 6 ? "h-56 overflow-y-scroll" : ""}`}
        >
          {searchList.map((item) => {
            return item.label != null && item.label !== undefined ? (
              <li key={`${item.value} + ${item.label}`} className="flex">
                <input
                  type="checkbox"
                  id={`${item.value}_${item.label}_${category}`}
                  name={item.label}
                  value={item.value.toString().toLowerCase()}
                  className="cursor-pointer accent-dark-blue"
                  onChange={handleCheckbox}
                />
                <label
                  htmlFor={`${item?.value}_${item?.label}_${category}`}
                  className={`filterCheckInputLabel ${
                    item.color ? `${item.color}` : ""
                  }`}
                >
                  {item.label}
                </label>
              </li>
            ) : (
              ""
            );
          })}
        </ul>
      ) : (
        <p className="filterSearchErr">Not Found</p>
      )}
    </div>
  );
};
export default MobileFilterListItem;
